import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SplashPage } from './splash';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    SplashPage,
  ],
  imports: [
    IonicPageModule.forChild(SplashPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class SplashPageModule {}



// WEBPACK FOOTER //
// ./src/pages/splash/splash.module.ts